import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

let nextEffectsDialogId = 0;

/** Render saved text literally. No generated claims, HTML, or markdown interpretation. */
export default function ProductEffects({ product }) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const closeRef = useRef(null);
  const dialogId = useRef(null);
  if (!dialogId.current) dialogId.current = `product-effects-${++nextEffectsDialogId}`;
  const text = product?.effects === undefined || product?.effects === null ? '' : String(product.effects);
  const hasEffects = text.trim() !== '';

  useEffect(() => {
    if (!open) return undefined;
    closeRef.current?.focus();
    const trigger = triggerRef.current;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        setOpen(false);
      }
      if (event.key === 'Tab') {
        event.preventDefault();
        closeRef.current?.focus();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      trigger?.focus();
    };
  }, [open]);

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        className="product-effects-button"
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label={`查看功效${product?.name ? `：${product.name}` : ''}`}
        disabled={!hasEffects}
        title={hasEffects ? '查看已儲存的功效文字' : '尚未填寫功效'}
        onClick={(event) => { event.stopPropagation(); setOpen(true); }}
      >
        {hasEffects ? '查看功效' : '尚無功效'}
      </button>
      {open && createPortal(
        <div
          className="product-effects-backdrop"
          style={{ position: 'fixed', inset: 0, background: 'rgba(15, 23, 42, 0.52)', zIndex: 2200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
          onClick={(event) => { event.stopPropagation(); if (event.target === event.currentTarget) setOpen(false); }}
        >
          <section
            role="dialog"
            aria-modal="true"
            aria-labelledby={`${dialogId.current}-title`}
            style={{ background: '#fff', color: '#172033', borderRadius: 12, padding: 24, width: '100%', maxWidth: 660, maxHeight: '85vh', overflowY: 'auto', boxSizing: 'border-box' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16 }}>
              <h2 id={`${dialogId.current}-title`} style={{ margin: 0, fontSize: 22 }}>商品功效</h2>
              <button ref={closeRef} type="button" onClick={() => setOpen(false)} aria-label="關閉功效視窗">關閉</button>
            </div>
            <p style={{ color: '#475569', overflowWrap: 'anywhere' }}>{product?.itemNumber || ''}{product?.itemNumber && product?.name ? ' · ' : ''}{product?.name || ''}</p>
            <div style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', lineHeight: 1.8 }}>{text}</div>
          </section>
        </div>,
        document.body,
      )}
    </>
  );
}
